@use "./LynePicker.scss";

.board-picker {
  // for reference only.

  zoom: 1;
}
